
$(document).ready(function () {

// Custom Icon With Text

$(".slick-testimonials").slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 600,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1
  });


  $('#slick-as-seen').slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    pauseOnHover: true,
    cssEase: 'linear',	
    slidesToShow: 8,
    speed: 4000,
    slidesToScroll: 1,
    responsive: [
        {
        breakpoint: 1199,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });

   $(".slick-highlights").slick({
      dots: false,
      arrows: true,
      infinite: false,
      autoplay: false,
      speed: 600,
      autoplaySpeed: 4000,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });


     $(".slick-client-review-single").slick({
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: false,
      speed: 600,
      autoplaySpeed: 4000,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  // Review Grid slider for mobile screen


  // Quick review

    $(".slick-quick-reivew").slick({
        dots: true,
        arrows: false,
        infinite: true,
        autoplay: false,
        speed: 600,
        autoplaySpeed: 4000,
        slidesToShow: 1,
        slidesToScroll: 1
    });
});

